export const FRESH_FEAST_TRIAL_FLOW = "fresh-feast-trial";
export const SEVEN_DAY_TRIAL_FLOW = "seven-day-trial";
export const AC_SOURCE_QUERY_PARAM = "ac_source";
export const ABANDONED_CART_CHANNEL = "abandoned-cart";
